export enum TERMS_TYPE {
    Default = "DEFAULT",
    Market = "MARKETING",
    Finance = "FINANCE_AND_PAYMENT"
}